/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
function loggedIn(originalMethod, context) {
  const methodName = context.name;
  function replacementMethod(...args) {
    if (!this.authenticated) {
      throw new Error(`Trying to access auth.${methodName}(), before auth.login()`);
    }
    return originalMethod.call(this, ...args);
  }
  return replacementMethod;
}
export default loggedIn;